import {PARAM_RATING} from '../constants';
import {createActionCreator} from 'PyzShopUi/scripts/shop-ui/includes/enhanced-reducer';

export interface ISetRatingPayload {
    [PARAM_RATING]?: number;
}

const SET_RATING = 'SET_RATING';

export const setRating = createActionCreator<ISetRatingPayload>(SET_RATING);
